// @see 'react-uuid' package
const uuid = (): string => {
    const hashTable = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ]
    const id = []
    for (let i = 0; i < 35; i++) {
        if (i === 7 || i === 12 || i === 17 || i === 22) {
            id[i] = '-'
        } else {
            id[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)]
        }
    }
    return id.join('')
}

const getCookieValue = (cookieName: string): string | null => {
    let res = null
    const cookieString = RegExp(`${cookieName}[^;]+`).exec(document.cookie)
    if (cookieString) {
        res = decodeURIComponent(cookieString.toString().replace(/^[^=]+./, ''))
    }
    return res
}

const createOrRenewCookie = (
    cookieName: string,
    defaultValue: string | null = null,
    expirationTime = 0
) => {
    const cookieValue = getCookieValue(cookieName) ?? defaultValue
    const currentDate = new Date()
    currentDate.setTime(currentDate.getTime() + expirationTime)
    const expires = expirationTime ? currentDate.toUTCString() : ''
    document.cookie = `${cookieName}=${cookieValue}; expires=${expires}; path=/`
}

const UNIQUE_IDENTIFIER_COOKIE = 'UUID'
export const getUUIDCookie = (uniqueIdentifierExpiresDays = 30): string => {
    const expirationTime = uniqueIdentifierExpiresDays * 24 * 60 * 60 * 1000
    createOrRenewCookie(UNIQUE_IDENTIFIER_COOKIE, uuid(), expirationTime)
    return String(getCookieValue(UNIQUE_IDENTIFIER_COOKIE))
}

const IS_VISITOR_NEW_COOKIE = 'isVisitorNew'
export const checkIsVisitorNew = (
    isVisitorNewCookieExpiresHours = 1
): boolean => {
    // A visitor is a new one if they do not have UUID or their isVisitorNew cookie has not expired
    const isVisitorNew =
        !getCookieValue(UNIQUE_IDENTIFIER_COOKIE) ||
        !!getCookieValue(IS_VISITOR_NEW_COOKIE)
    if (isVisitorNew) {
        const expirationTime = isVisitorNewCookieExpiresHours * 60 * 60 * 1000
        createOrRenewCookie(IS_VISITOR_NEW_COOKIE, null, expirationTime)
    }
    return isVisitorNew
}
